import { IFilterReactComp } from "ag-grid-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import DeleteIcon from "../../../../assets/images/deleteIcon.svg";
import SelectCustom from "../../../SelectCustom";

export interface CustomTextFilterModel {
  value: string;
}

const CustomFilter = forwardRef<IFilterReactComp, any>((props: any, ref) => {
  const [filterValue, setFilterValue] = useState<string | number | boolean>("");
  const [initialDate, setInitialDate] = useState<string>("");
  const [finalDate, setFinalDate] = useState<string>("");
  const [selected, setSelected] = useState<any>(null);
  const [selectInputValue, setSelectInputValue] = useState("");
  const [selectKey, setSelectKey] = useState(0);

  const filterValueRef = useRef<string | number | boolean>("");
  const initialDateRef = useRef<string>("");
  const finalDateRef = useRef<string>("");

  const normalizeTextValue = (value: string | number | boolean) => {
    const normalizedValue = String(value ?? "");

    if (props.colDef.fieldName === "identificadores_conteineres") {
      return normalizedValue.replace(/^\{/, "").replace(/\}$/, "");
    }

    return normalizedValue;
  };

  const updateFilterValue = (val: string | number | boolean) => {
    filterValueRef.current = val;
    setFilterValue(val);
  };

  const updateInitialDate = (val: string) => {
    initialDateRef.current = val;
    setInitialDate(val);
  };

  const updateFinalDate = (val: string) => {
    finalDateRef.current = val;
    setFinalDate(val);
  };

  const clearFilterState = () => {
    updateFilterValue("");
    updateInitialDate("");
    updateFinalDate("");
    setSelected(null);
    setSelectInputValue("");
    setSelectKey((prev) => prev + 1);
  };

  // Implementação da interface de filtro
  useImperativeHandle(ref, () => ({
    doesFilterPass(params) {
      return params.data[props.colDef.field]?.toString().toLowerCase();
      // .includes(filterValue.toLowerCase());
    },
    isFilterActive() {
      if (props.dateBetween) {
        return initialDateRef.current.length > 0 && finalDateRef.current.length > 0;
      }
      return filterValueRef.current !== "";
    },
    getModel(): any | null {
      if (filterValueRef.current === "" && !initialDateRef.current && !finalDateRef.current) {
        return null; // Remove o filtro do AG Grid
      }

      let value: any = String(filterValueRef.current).length > 0 ? filterValueRef.current : null;
      if (props.dateBetween) {
        value = [initialDateRef.current, finalDateRef.current];
      }

      const fieldName = props.colDef.fieldName || props.colDef.field;

      console.log(value);

      return { value, field: fieldName };
    },
    setModel(model: CustomTextFilterModel | null) {
      console.log(model);
      
      const newValue = model ? (model.value || "") : "";
      // Check if value actually changes to avoid stuck flag
      if (JSON.stringify(newValue) !== JSON.stringify(filterValueRef.current)) {
         isUpdatingFromParent.current = true;
      }

      if (!model) {
        clearFilterState();
      } else {
        if (props.dateBetween && Array.isArray(model.value)) {
          updateInitialDate(model.value[0]);
          updateFinalDate(model.value[1]);
        } else {
            updateFilterValue(normalizeTextValue(model.value || ""));
        }
        
        if (props.selected && Array.isArray(props.selected.data)) {
          const found = props.selected.data.find(
            (item: any) => item.value == model.value
          );
          if (found) {
            setSelected(found);
          }
        }
        setSelectInputValue("");
      }
    },
  }));

  const isMounted = useRef(false);
  const isUpdatingFromParent = useRef(false);
  const filterChangedCallbackRef = useRef(props.filterChangedCallback);

  // Update ref on every render to ensure we have the latest callback
  filterChangedCallbackRef.current = props.filterChangedCallback;

  useEffect(() => {
    if (!isMounted.current) return;

    if (isUpdatingFromParent.current) {
      isUpdatingFromParent.current = false;
      return;
    }

    filterChangedCallbackRef.current();
  }, [filterValue, initialDate, finalDate]);

  useEffect(() => {
    isMounted.current = true;
  }, []);

  console.log(props);

  return (
    <div className="w-full h-full rounded-sm p-4 relative">
      <div className="flex justify-end mr-2 mb-4">
        <button
          className="flex items-center justify-center border-none bg-transparent text-[#EA004C] text-sm font-bold"
          onClick={() => {
            clearFilterState();
          }}
        >
          <img src={DeleteIcon} alt="" className="mr-2" />
          Limpar Filtros
        </button>
      </div>
      {props.selected ? (
        <SelectCustom
          key={selectKey}
          data={props.selected.data}
          isMulti={props.selected.isMultiple}
          inputValue={selectInputValue}
          onChange={(selectedOption: any) => {
            if (
              !window.location.pathname.includes("triagens") &&
              props.colDef.fieldName === "tipo_carga" &&
              props.selected.isMultiple
            ) {
              console.log(selectedOption);
              setSelected(selectedOption);
              setSelectInputValue("");
              let dataCargoTypes = "{";
              selectedOption.map((item: any) => {
                dataCargoTypes = dataCargoTypes.concat(item.value) + ",";
              });
              let value = dataCargoTypes.replace(/,$/, "");
              value = value.concat("}");
              updateFilterValue(value);
            } else {
              console.log(props.colDef);
              console.log("entrou select", Number(selectedOption));
              setSelected(selectedOption);
              setSelectInputValue("");
              if (!selectedOption) {
                updateFilterValue("");
              } else if (
                props.colDef.type === "booleanColumn" ||
                isNaN(Number(selectedOption.value))
              ) {
                updateFilterValue(selectedOption.value);
              } else {
                updateFilterValue(Number(selectedOption.value));
              }
            }
          }}
          onInputChange={(value: string, actionMeta: any) => {
            if (actionMeta.action === "input-change") {
              setSelectInputValue(value);
            }

            if (actionMeta.action === "menu-close" || actionMeta.action === "set-value") {
              setSelectInputValue("");
            }
          }}
          title=""
          value={selected}
        />
      ) : props.dateBetween ? (
        <div className="flex items-center justify-center">
          <input
            onChange={(e: any) => {
              const dateColumn = format(e.target.value, "yyyy-MM-dd HH:mm", {
                locale: ptBR,
              });

              updateInitialDate(dateColumn);
            }}
            value={initialDate}
            placeholder="Pesquisar..."
            type="datetime-local"
            className="w-full h-8 rounded-full p-2 shadow-lg border-[#DBDEDF] border-2 mr-2"
          />
          <input
            onChange={(e: any) => {
              const dateColumn = format(e.target.value, "yyyy-MM-dd HH:mm", {
                locale: ptBR,
              });

              updateFinalDate(dateColumn);
            }}
            value={finalDate}
            placeholder="Pesquisar..."
            type="datetime-local"
            className="w-full h-8 rounded-full p-2 shadow-lg border-[#DBDEDF] border-2"
          />
        </div>
      ) : (
        <input
          onChange={(e: any) => {
            if (props.colDef.type === "dateColumn") {
              const dateColumn = format(e.target.value, "yyyy-MM-dd HH:mm", {
                locale: ptBR,
              });

              updateFilterValue(dateColumn);
            } else {
              if (e.target.value.length == 0) {
                updateFilterValue("");
              } else {
                const value = normalizeTextValue(e.target.value).toUpperCase();

                updateFilterValue(value);
              }
            }
          }}
          value={String(filterValue)}
          placeholder="Pesquisar..."
          type={
            props.colDef.type === "dateColumn"
              ? "datetime-local"
              : props.colDef.type === "numberColumn"
              ? "number"
              : "text"
          }
          className="w-full h-8 rounded-full p-2 shadow-lg border-[#DBDEDF] border-2"
        />
      )}

      {/* <Listbox
        value={filterValue}
        onChange={(value: any) => {
          setFilterValue(String(value.id));
          setSelected(value);
        }}
      >
        <Listbox.Button className="w-[275px] h-9 rounded-[32px] border-[#DBDEDF] border-2 shadow-lg pl-2">
          <div className="flex items-center gap-2">
            {selected ? (
              <>
                <span
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: selected?.icon }}
                />
                {selected?.label}
              </>
            ) : (
              <>Selecione uma opção</>
            )}
            <div className="absolute right-7">
              <KeyboardArrowDownIcon />
            </div>
          </div>
        </Listbox.Button>
        <Listbox.Options className="w-full mt-1 bg-white border rounded-md shadow-lg h-[220px] overflow-scroll">
          {props.status.map((item: any) => (
            <Listbox.Option
              // key={item.value}
              value={item}
              className="flex items-center gap-2 px-4 p-2 py-2 cursor-pointer hover:bg-gray-100 "
            >
              <span
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: item.icon }}
              />
              {item.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox> */}
    </div>
  );
});

export default CustomFilter;
